export default __webpack_public_path__ + "d54aa37737e7f3b2d3abd220f7a54185.png";